import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ConfigurationResult } from '@mews-distributor/data-access';
import { keyById } from '@mews/fp';
import { FETCH_CONFIGURATIONS_SUCCEEDED } from '../../configuration/actionTypes';

const chainsSlice = createSlice({
    name: 'chains',
    initialState: {},
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            FETCH_CONFIGURATIONS_SUCCEEDED,
            (
                state,
                { payload: { chains } }: PayloadAction<ConfigurationResult, typeof FETCH_CONFIGURATIONS_SUCCEEDED>
            ) => keyById(chains)
        );
    },
});

export const { reducer: chainsReducer } = chainsSlice;
